import { render, staticRenderFns } from "./index_productSpecification.vue?vue&type=template&id=39186c9c&scoped=true"
import script from "./index_productSpecification.vue?vue&type=script&lang=js"
export * from "./index_productSpecification.vue?vue&type=script&lang=js"
import style0 from "./index_productSpecification.vue?vue&type=style&index=0&id=39186c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39186c9c",
  null
  
)

export default component.exports